<template>
  <div class="slds-notification-container">
    <transition-group name="fade">
      <Notification
        v-for="notification in notifications"
        :icon="notification.icon"
        :title="notification.title"
        :text="notification.text"
        :params="notification.params"
        :url="notification.url"
        :key="notification.id"
        @removeNotification="removeNotification(notification.id)"
      />
    </transition-group>
  </div>
</template>
<script>
import EventBus from '../utils/EventBus'
import Notification from './Notification'
export default {
  components: {
    Notification
  },
  data () {
    return {
      notifications: []
    }
  },
  methods: {
    addNotification (icon, title, text, url, fixed) {
      const notificationId = parseInt(Math.random() * 100000)
      this.notifications.push({ id: notificationId, icon, title, text, url })
      if (!fixed) {
        setTimeout(() => { this.removeNotification(notificationId) }, 3000)
      }
    },
    removeNotification (id) {
      const index = this.notifications.find(n => n.id === id)
      this.notifications.splice(index, 1)
    }
  },
  mounted () {
    EventBus.$on('add-notification', params => this.addNotification(params.icon, params.title, params.text, params.url, params.fixed))
  }
}
</script>
